const SESSION_KEY = "gg-hub.session";

export interface SessionUser {
  name: string;
  email: string;
  picture?: string;
  user_type: "collaborator" | "candidate";
  roles: string[];
  permissions: string[];
  [key: string]: unknown;
}

interface Session {
  token: string;
  user: SessionUser;
  expiresAt: number | null;
}

interface SaveSessionParams {
  token: string;
  user: SessionUser;
  expiresIn?: number;
}

export function saveSession({ token, user, expiresIn }: SaveSessionParams) {
  const expiresAt =
    typeof expiresIn === "number" ? Date.now() + expiresIn * 1000 : null;
  localStorage.setItem(
    SESSION_KEY,
    JSON.stringify({ token, user, expiresAt })
  );
}

export function getSession(): Session | null {
  const raw = localStorage.getItem(SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed: Session = JSON.parse(raw);
    if (parsed.expiresAt && parsed.expiresAt < Date.now()) {
      clearSession();
      return null;
    }
    return parsed;
  } catch {
    clearSession();
    return null;
  }
}

export function getToken(): string | null {
  return getSession()?.token ?? null;
}

export function getUser(): SessionUser | null {
  return getSession()?.user ?? null;
}

export function clearSession() {
  localStorage.removeItem(SESSION_KEY);
}

export function isAuthenticated(): boolean {
  return getToken() !== null;
}

export function getUserType(): string | null {
  return getUser()?.user_type ?? null;
}

export function hasRole(role: string): boolean {
  return getUser()?.roles?.includes(role) ?? false;
}

export function hasPermission(permission: string): boolean {
  return getUser()?.permissions?.includes(permission) ?? false;
}